import Yup from 'utils/validation/yup-extensions';
import Box from '@mui/material/Box';
import AppWrappedSelect from 'pages/ApplicationRequest/components/containers/AppWrappedSelect';

const RADIOLOGY_VENDOR_OPTIONS = [
	{ key: '100', value: 'External Provider' },
	{ key: '101', value: 'Foundation' },
	{ key: '102', value: 'Nighthawk' },
	{ key: '103', value: 'Quantum' },
	{ key: '104', value: 'TeleRadiology' },
	{ key: '105', value: 'Vrad' },
	{ key: '106', value: 'Allegheny' },
	{ key: '107', value: 'Susquehanna' },
	{ key: '108', value: 'Penn State Path' },
	{ key: '109', value: 'Potomac' },
	{ key: '110', value: 'Path Assoc CPA' },
	{ key: '111', value: 'Jamestown' },
	{ key: '112', value: 'APS' },
	{ key: '113', value: 'Muse' },
	{ key: '114', value: 'OIP' },
	{ key: '115', value: 'Kidney Care' },
	{ key: '116', value: 'UPP Quantum' },
];

export const FORM_FIELD_KEYS = {
	RADIOLOGY_VENDOR: 'RADIOLOGY_VENDOR',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.RADIOLOGY_VENDOR]: '',
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.RADIOLOGY_VENDOR]: Yup.string().required(
		'Please select a vendor.',
	),
};

/**
 * Radiology vendor supplement form fields.
 * @param {{ formik: import('formik').FormikProps<object> }} props
 */
export const RadiologySupplement = ({ formik }) => {
	return (
		<Box>
			<AppWrappedSelect
				name={FORM_FIELD_KEYS.RADIOLOGY_VENDOR}
				label='Radiology Vendor'
				formik={formik}
				options={RADIOLOGY_VENDOR_OPTIONS}
				isRequired
			/>
		</Box>
	);
};
